/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import React from 'react';
import styled, { StyledComponent } from '@emotion/styled';
import View from './view';

type TouchableOpacityProps = React.ComponentProps<typeof View> & {
  disabled?: boolean;
};

const TouchableOpacity: StyledComponent<TouchableOpacityProps> = styled(View)(
  (props) => ({
    userSelect: 'none',
    cursor: props.disabled ? 'default' : 'pointer',
  }),
);

export default TouchableOpacity;
